import React, { ReactElement } from 'react';
import { FaMoneyBillAlt } from 'react-icons/fa';
import {
  FiAlertTriangle,
  FiArrowRight,
  FiEye,
  FiHome,
  FiMapPin,
  FiPlus,
  FiUser,
} from 'react-icons/fi';

import { Aircraft } from '@/API/models';
import { AircraftPlaceholderIcon } from '@/components/AircraftPlaceholderIcon';
import { AIRCRAFT_PLACEHOLDER_ICONS_LIGHT } from '@/Utils/constants';

const Property: React.FC<{ className?: string; onClick?: () => void }> = ({
  children,
  className = '',
  onClick,
}) => (
  <div
    className={`p-2 flex items-center gap-3 w-2/5 flex-auto sm:h-12 ${className}`}
    onClick={onClick}
  >
    {children}
  </div>
);

const Btn: React.FC<{
  className?: string;
  onClick?: () => void;
  href?: string;
}> = ({ children, className, onClick, href }) => {
  return (
    <a
      href={href}
      className={`flex justify-between p-4 flex-1 min-w-max gap-4 btn ${className}`}
      onClick={onClick}
    >
      {children}
    </a>
  );
};

const NoImage = ({ placeholderIcon }: { placeholderIcon: ReactElement }) => (
  <div className='w-full h-72 bg-aircraftPlaceholderDark text-gray-500 text-center flex justify-center items-center flex-col rounded-t-xl'>
    {/* TODO: EL-947 #5 */}
    {placeholderIcon}
    <p className='text-aircraftPlaceholderLight'>No Image</p>
  </div>
);

type Props = {
  aircraft: Aircraft;
  operatorId?: string;
  add: (ac: Aircraft) => void;
  view: (ac: Aircraft) => void;
};

const AircraftCard: React.FC<Props> = ({ aircraft, add, view, operatorId }) => {
  return (
    <div className='flex flex-col transition-all shadow-md hover:shadow-lg text-gray-600 border-2 rounded-xl  box-border overflow-hidden'>
      <a
        href={`/operator/aircrafts/${aircraft.id}/edit${
          operatorId ? `?operator_id=${operatorId}` : ''
        }`}
        className='rounded-t-xl'
      >
        {aircraft.image ? (
          <div
            className='h-72 bg-aircraftPlaceholderDark bg-center bg-cover rounded-t-xl'
            style={{ backgroundImage: `url(${aircraft.image})` }}
          />
        ) : (
          <NoImage
            placeholderIcon={
              <AircraftPlaceholderIcon
                src={
                  AIRCRAFT_PLACEHOLDER_ICONS_LIGHT[
                    aircraft.price_config_name.trim()
                  ]
                }
              />
            }
          />
        )}
        <Property className='m-4 text-xl w-max  max-w-full'>
          {/* <h3 className='px-8'>{aircraft.craft_type_model_name}</h3> */}
          <p>
            {`${aircraft.tail_number}, ${aircraft.price_config_name.trim()}, ${
              aircraft.aircraft_type ?? ''
            }, ${aircraft.craft_type_model_name}`}
          </p>
        </Property>
      </a>
      <dl className='px-4 flex flex-wrap gap-2 mb-4 h-full'>
        <Property>
          <FiUser size={20} className={'flex-shrink-0'} />
          <span>Max {aircraft.capacity}</span>
        </Property>
        <Property>
          <FaMoneyBillAlt size={20} className={'flex-shrink-0'} />
          <span>${aircraft.wholesale_hourly_rate}/hr.</span>
        </Property>
        <Property>
          <FiHome size={20} className={'flex-shrink-0'} />
          <span>{aircraft.home_vertiport_code ?? 'Home'}</span>
        </Property>
        <Property>
          <FiMapPin size={20} className={'flex-shrink-0'} />
          <span>{aircraft.current_vertiport ?? 'Current'}</span>
        </Property>

        {!aircraft.completed || !aircraft.aircraft_type ? (
          <Property className='bg-yellow-100 w-full text-yellow-800 p-4 rounded-lg'>
            <FiAlertTriangle size={20} />
            <span>Aircraft Not Complete</span>
          </Property>
        ) : (
          <div style={{ height: 50, width: '100%' }} />
        )}
        <div className='w-full mt-4'>
          <div className='flex flex-1 gap-3 flex-wrap sm:flex-nowrap'>
            <Btn
              className='self-end justify-between'
              href={`/operator/aircrafts/${aircraft.id}/edit${
                operatorId ? `?operator_id=${operatorId}` : ''
              }`}
            >
              <span>Edit</span>
              <FiArrowRight size={20} />
            </Btn>
            <Btn
              className='self-end justify-between'
              href={`/operator/aircrafts/${aircraft.id}/aircraft_availabilities${
                operatorId ? `?operator_id=${operatorId}` : ''
              }`}
            >
              <span>Calendar</span>
              <FiArrowRight size={20} />
            </Btn>
          </div>
          <div className='flex flex-1 gap-3 flex-wrap sm:flex-nowrap'>
            <Btn
              className='self-end justify-between mt-4'
              onClick={() => {
                view(aircraft);
              }}
            >
              <span>View One-Way Special</span>
              <FiEye size={20} />
            </Btn>
            <Btn
              className='self-end justify-between'
              onClick={() => {
                add(aircraft);
              }}
            >
              <span>Add One-Way Special</span>
              <FiPlus size={20} />
            </Btn>
          </div>
        </div>
      </dl>
    </div>
  );
};
export default AircraftCard;
